<template>
    <div class="investment">
        <div class="header">

          <div class="t-left">
            CASE
          </div>
          <div class="t-right">
            <div>
              行业案例
            </div>
            <div>
              INDUSTRY CASE
            </div>
          </div>



        </div>


        <div class="case-wrap clearfix">


          <div class="case-box fl">
            <div class="case-title">
                佛山翡翠艺术馆有源RFID应用行业案例
            </div>
            <div class="case-info clearfix">
              <div class="case-source fl">
                来源：艺品天下           
              </div>
              <div class="case-time fl">
                2021/12/03 11:21:25
              </div>
            </div>
            <div class="case-content">
              货物快速出入库、总部对各分店货品的精确管理，杜绝差错和丢失 。
总部准确掌握分店每天货品在库或在柜情。
RFID 3D盘点技术使用在库房收发货过程中，快速准确出入库，接收或发出人均在系统中刷RFID卡做身份确
认，确保哪个环节出现问题及时发现，不给下个环节带来问题。
标准化各部门间的工作流程，所有交接通过RFID员工卡确认，责任落实到具体人。 
交接班实现日盘。
统计报表详实，包含各类趋势分析，RFID精确单品管理确保帐实相符 。
            </div>
          </div>
          

          <div class="case-btn fr">
            <div class="btn-list">
              <img src="../assets/caseDeleft.png" alt="">
            </div>
            <div class="btn-list">
              返回
            </div>
            <div class="btn-list">
              <img src="../assets/caseDelright.png" alt="">
            </div>
          </div>  


        </div>





    </div>

</template>
<script>
  export default {
    name: "investment",
    data(){
      return{
       
      }
    },
    mounted(){
    },
    methods:{
     
    },
    created:function(){

    },
    watch:{

    },
  }
</script>
<style scoped>
.investment{
  padding-bottom: 108px;
  overflow-x: hidden;
}


.header{
  width: 1160px;
  margin: 96px auto;
  position: relative;
}
.header:after{ 
  content:"";
  width: 9000px;
  height: 2px;
  background: #000000;
  position: absolute;
  bottom: 0;
  left: -8678px;
}


.t-left,.t-right{
  display: inline-block;
  vertical-align: middle;
}
.t-left{
  font-size: 60px;
  color: #3575E1;
  margin-left: 50px;
}
.t-right div:nth-child(1){
  font-size: 30px;
  color: #000000;
}
.t-right div:nth-child(2){
  font-size: 14px;
  color: #999999;
}

.case-wrap{
  width: 1160px;
  margin: 50px auto;
}
.case-box{
  width: 960px;
  padding: 42px;
  background: #fff;
  box-shadow: 0px 0px 10px rgba(0,0,0,.5);
}
.case-title{
  font-size: 24px;
  color: #333333;
}
.case-info{
  font-size: 14px;
  color: #999999;
  margin: 18px 0 30px;
}
.case-content{
  font-size: 16px;
  color: #666666;
  line-height: 30px;
}
.case-btn{
  width: 50px;
  
}
.btn-list{
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin-bottom: 30px;
  box-shadow: 0px 0px 10px rgba(0,0,0,.5);
  cursor: pointer;
  font-size: 14px;
  color: #3575E1;
}
.btn-list img{
  display: inline-block;
  width: 28px;
}







</style>



// WEBPACK FOOTER //
// src/components/investmentDetails.vue